import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationEN from "./locales/en/translation.json";
import translationPT from "./locales/pt/translation.json";
import translationES from "./locales/es/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  pt: {
    translation: translationPT,
  },
  es: {
    translation: translationES,
  },
};

export const languageCodes = {
  "pt-PT": 1,
  "en-GB": 2,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en", // use pt if detected lng is not available
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
